import { useState } from 'react';

import { SECURE_API } from 'src/api/api';
import Loader from 'src/common/components/Loader';
import Resolver from 'src/common/Resolver';
import { IMyResult } from 'src/interfaces/MyResult';
import MyResultsPage from './MyResultsPage';

const MyResultsResolver = () => {
  const [results, setResults] = useState<IMyResult[] | null>(null);

  if (results === null) {
    return (
      <Resolver
        resolve={() =>
          SECURE_API.get<IMyResult[]>('/me/results').then(({ data }) => data ?? [])
        }
        onSuccess={rows => setResults(Array.isArray(rows) ? rows : [])}
        successComponent={() => <Loader isLoading />}
      />
    );
  }

  return <MyResultsPage results={results} />;
};

export default MyResultsResolver;
